export enum VehicleIntendedUse {
    UNSPECIFIED = 'unspecified',
    LIMITED_BENEFIT = 'limited-benefit',
    FULL_BENEFIT = 'full-benefit',
    COMMERCIAL = 'commercial',
    PRIVATE = 'private',
}
